import React from 'react';
import { SkeletonLoader } from '../../components';

import s from './HostStyles.module.scss';

const SkeletonLoaderHost = () => (
    <div className={s.editor} style={{ padding: '100px' }}>
        <SkeletonLoader />
    </div>
);

export default SkeletonLoaderHost;
